import * as React from "react";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Input, Button } from "antd";
import whiteLogo from "../../../core/ui/assets/images/headerlogo.png";
const LoginForm = ({
  translate,
  username,
  password,
  loginButtonDisabled,
  login,
  onChangeUsername,
  onChangePassword,
  loading
}: {
  translate: any;
  username?: string;
  password?: string;
  loginButtonDisabled: boolean;
  login: any;
  onChangeUsername: any;
  onChangePassword: any;
  loading: boolean;
}) => {
  return (
    <div className="login-container">
      <div className="login-form-container">
        <img
          src={whiteLogo}
          style={{ marginBottom: 30 }}
          alt={translate("app.title")}
        />
        <div className="app-title">{translate("app.title")}</div>
        <div className="login-form-items-container">
          <Input
            prefix={<UserOutlined className={"input-icon"} />}
            placeholder={translate("login.username")}
            value={username}
            onChange={(e) => onChangeUsername(e.target.value)}
            allowClear={true}
            className={"inputStyle"}
            autoFocus={true}
          />
          <Input.Password
            prefix={<LockOutlined className={"input-icon"} />}
            placeholder={translate("login.password")}
            value={password}
            onPressEnter={login}
            onChange={(e) => onChangePassword(e.target.value)}
            allowClear={true}
            className={"inputStyle"}
          />
          <Button
            type="primary"
            disabled={loginButtonDisabled}
            onClick={login}
            className="login-button"
            loading={loading}
          >
            {translate("login.login")}
          </Button>
        </div>
        <div className="copyright">{translate("app.copyright_text")}</div>
      </div>
    </div>
  );
};

export default LoginForm;
